module.exports = __webpack_public_path__ + "img/mtel-404.f4f9ca11.png";